<template>
  <div class="ModalContent">
    <h3 class="title" v-html="title"></h3>
    <div class="content" v-html="content"></div>
    <div class="btn" v-if="ctaHref">
      <a :href="ctaHref" target="_blank" v-html="ctaText" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ModalContent',
    data(){
      return {
      }
    },
    components:{
    },
    props: {
      title: {
        type: String,
        default: ""
      },
      ctaHref: {
        type: String,
        default: ""
      },
      ctaText: {
        type: String,
        default: ""
      },
      content: {
        type: String,
        default: "#000"
      }
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/_fonts';
  .title{
    .CB;
    margin: 0;
    font-size: 24px;
  }

  .content{
    margin: 20px 0 40px;
    font-size: 18px;
    line-height: 26px;
    a:link, a:visited, a:hover, a:active{
      color: var(--special-network-color);
    }
  }

  .btn{
    a{ 
      display: block;
      padding: 12px 0; 
      text-align: center;
      &:link, &:visited, &:hover, &:active{
        text-decoration: none;
        background: var(--special-network-color);
        color: #fff;
        font-size: 15px;
        .CB;
        line-height: 26px;
      }
    }
  }
</style>
